import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainCreatCarport(data) {
  return maintainRequest({
    url: `/device/maintenanceMan/carport/creatCarport`,
    method: "post",
    data,
  });
}
